import React, { useContext } from "react";
import {
  faClone,
  faPencil as PencilIcon,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";
import IconButton from "../../../../../components/IconButton";
import Checkbox from "../../../../../components/Forms/Checkbox";

export default function ParkingSlotTable({
  parkingSlots,
  callbackSetParkingSlot,
  callbackSetSelectedTPS,
  callbackSetConfirmText,
  selectedParkingSlotIds = [],
  onToggleSelectedParkingSlot,
  selectionDisabled = false,
}) {
  function handleToggleActive(parkingSlot) {
    callbackSetSelectedTPS(parkingSlot);
    callbackSetConfirmText?.(
      "Möchten Sie den Parkingslot '" +
        (parkingSlot?.name ?? "") +
        "' wirklich " +
        (parkingSlot.active ? "deaktivieren?" : "aktivieren?")
    );
  }

  return (
    <div className="ui-table-container category-colors">
      <table
        className="table table-bordered"
        id="dataTable"
        width="100%"
        cellSpacing="0"
      >
        <tbody>
          {parkingSlots?.entries?.map((parking_slot) => (
            <tr key={parking_slot.id}>
              <td>
                <Checkbox
                  name={`select-grouped-slot-${parking_slot.id}`}
                  aria-label={`Stellplatz ${parking_slot.name} auswählen`}
                  checked={selectedParkingSlotIds.includes(parking_slot.id)}
                  disabled={selectionDisabled}
                  onChange={() => onToggleSelectedParkingSlot(parking_slot.id)}
                  className="parking-slot-selection"
                />
              </td>
              <td>
                <b>{parking_slot.name}</b>
              </td>
              <td>
                <span
                  className={
                    "badge " +
                    (parking_slot?.category?.name
                      ? `badge-parking`
                      : "badge-secondary")
                  }
                  style={
                    parking_slot?.category
                      ? { backgroundColor: parking_slot.category.color.value }
                      : {}
                  }
                >
                  {parking_slot?.category?.name}
                </span>
              </td>

              <td>
                {/* {parking_slot.day_price ? euroFormatter(parking_slot?.day_price) : euroFormatter(parking_slot?.category?.price)} */}
              </td>

              <td>
                <Row>
                  <Col className="col-auto text-primary">
                    <IconButton
                      size="sm"
                      textColor="#2769d8"
                      className="bg-transparent border-0"
                      icon={PencilIcon}
                      onClick={() => {
                        callbackSetParkingSlot(parking_slot);
                      }}
                    />
                  </Col>

                  <Col className="col-auto">
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={`id${parking_slot.id}`}
                        checked={parking_slot.active}
                        onChange={() => handleToggleActive(parking_slot)}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={`id${parking_slot.id}`}
                      >
                        Aktiv
                      </label>
                    </div>
                  </Col>
                </Row>
              </td>
            </tr>
          ))}
          {(parkingSlots?.entries?.length ?? 0) === 0 && (
            <tr>
              <td>Keine Stellplätze vorhanden</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
